import { render } from "./PageNotFoundView.vue?vue&type=template&id=151b1496&scoped=true&ts=true"
import script from "./PageNotFoundView.vue?vue&type=script&lang=ts"
export * from "./PageNotFoundView.vue?vue&type=script&lang=ts"

import "./PageNotFoundView.vue?vue&type=style&index=0&id=151b1496&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-151b1496"]])

export default __exports__